import { FilterList, Search } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  CcfBox,
  CcfCalendarPlusIcon,
  CcfDeboucedInput,
  useTranslator,
} from '@nice-ccf/ui-controls';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import CcfInteractionsFilterPopover from '../ccf-consumer-card-interactions-tab/ccf-interactions-filter-popover/ccf-interactions-filter-popover';
import styles from '../ccf-consumer-card-tickets-tab/ccf-consumer-card-tickets-tab.module.scss';
import { useSelector } from 'react-redux';
import { getAppSpaceRatio } from '../../../global.app.slice';

/* eslint-disable-next-line */
export interface CcfConsumerCardTicketsTabHeaderProps {
  searchHandler: any;
  handleFilter: any;
  selectedFilterOption: any;
}

const useStyles: any = makeStyles({
  searchInput: {
    '& .MuiOutlinedInput-root': {
      height: '35px', // Set your desired height here
    },
  },
});

/**@example */
export function CcfConsumerCardTicketsTabHeader(
  props: CcfConsumerCardTicketsTabHeaderProps
) {
  const classes = useStyles();
  const { searchHandler, handleFilter, selectedFilterOption } = props;

  const [translate] = useTranslator();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [interactionsMinView, setInteractionsMinView] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const appSpaceRatio = useSelector(getAppSpaceRatio);
  useEffect(() => {
    const isMinView = appSpaceRatio && appSpaceRatio <= 40;
    setInteractionsMinView(isMinView);
  }, [appSpaceRatio]);

  const containerStyle = useMemo(
    () => ({
      width: interactionsMinView ? '50%' : '35%',
    }),
    [interactionsMinView]
  );
  /**
   * Function to select interaction view
   * @example handleSearch()
   */
  const handleSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const query = event.target.value.toLowerCase();
      setSearchQuery(query);
      searchHandler(query);
    },
    [searchHandler]
  );

  /**
   * Function to open the filter popover
   * @example handlePopoverOpen()
   */
  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * Function to close the filter popover
   * @example handlePopoverClose()
   */
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CcfBox className={styles.headercontainer}>
        <CcfBox style={containerStyle}>
          <CcfDeboucedInput
            size="small"
            style={{
              background: 'white',
            }}
            value={searchQuery}
            onChange={handleSearch}
            className={classes.searchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search htmlColor="grey" />
                </InputAdornment>
              ),
            }}
            placeholder={translate('search') + '...'}
            variant="outlined"
            fullWidth
            delay={1500}
          />
        </CcfBox>
        <CcfBox className={styles.btnContainer}>
          <IconButton style={{ pointerEvents: 'none' }}>
            <FilterList className={styles.btnIcon} />{' '}
          </IconButton>
          <IconButton>
            <CcfCalendarPlusIcon
              onClick={(e: any) => handlePopoverOpen(e)}
              className={styles.btnIcon}
            />{' '}
          </IconButton>
        </CcfBox>
      </CcfBox>
      <CcfInteractionsFilterPopover
        anchorEl={anchorEl}
        handlePopoverClose={handlePopoverClose}
        handleFilter={handleFilter}
        selectedFilterOption={selectedFilterOption}
      />
    </>
  );
}

export default CcfConsumerCardTicketsTabHeader;
